
<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>
            <div class="flex items-center gap-2">
                <mat-icon>credit_card</mat-icon>Subscription
            </div>
            </mat-card-title>
        <mat-card-subtitle>Create and manage your subscription</mat-card-subtitle>
    </mat-card-header>

    <mat-card-content>
        @let vm = viewState();

        <div class="mt-4 flex flex-col gap-6">

            <div class="flex flex-col gap-2">
                <h2 class="m-0">Current plan: {{vm.currentPlanName}}</h2>
                <p class="m-0">
                    @if (vm.hasPaidSubscription) {
                    Manage your paid subscription.
                    } @else {
                    Your account is on the Free plan. Purchase Pro to move to a paid subscription.
                    }
                </p>
            </div>

            @if (!vm.hasPaidSubscription) {
            <mce-info-message type="information">
                <div class="flexflex-col gap-4">
                    <p class="m-0">
                        Our <strong>Free Plan</strong> is for testing the application before subscribing. With
                        limited free credits, we suggest you create a project, add a cable, evaluate sizing
                        options, and print a few reports to determine whether the application meets your needs.
                    </p>


                    <p class="mt-2">
                        Free Plan restrictions (removed with Pro) include:
                        a maximum of 1 project, maxiumum of 3 cables and report watermarks.
                </div>
            </mce-info-message>
            }



            <div class="flex gap-4">
                <div>
                    <div class="border-outline flex flex-col gap-4 rounded border border-solid p-4">
                        <div class="flex flex-col gap-1">
                            <h3 class="m-0">{{vm.currentPlanName}}</h3>
                            <div>{{vm.currentPlanBilling}}</div>
                        </div>

                        <dl class="m-0 grid gap-2">
                            <div class="flex justify-between gap-4">
                                <dt>Credits</dt>
                                <dd class="m-0">{{vm.currentPlanCredits}}</dd>
                            </div>
                            <div class="flex justify-between gap-4">
                                <dt>Overage</dt>
                                <dd class="m-0 text-right">{{vm.currentPlanOverage}}</dd>
                            </div>
                        </dl>
                    </div>

                </div>
                <div>
                    @if (!vm.hasPaidSubscription) {
                    <div class="grid basis-1/3 gap-4 md:grid-cols-2">
                        @for (plan of vm.purchasePlans; track plan.key) {
                        <div class="border-outline flex flex-col gap-4 rounded border border-solid p-4">
                            <div class="flex flex-col gap-1">
                                <h3 class="m-0">{{plan.name}}</h3>
                                <div>{{plan.billing}}</div>
                            </div>

                            <dl class="m-0 grid gap-2">
                                <div class="flex justify-between gap-4">
                                    <dt>Credits</dt>
                                    <dd class="m-0">{{plan.credits}}</dd>
                                </div>
                                <div class="flex justify-between gap-4">
                                    <dt>Overage</dt>
                                    <dd class="m-0 text-right">{{plan.overage}}</dd>
                                </div>
                            </dl>

                            <button matButton="filled" class="mt-auto" type="button" (click)="checkoutOnClick(plan)"
                                    [showProgress]="vm.loading"
                                    [disabled]="vm.loading"
                                    [attr.aria-label]="checkoutLabel(plan) + ' plan'">
                                <mat-progress-spinner progressIndicator
                                                      mode="indeterminate"
                                                      [diameter]="20"
                                                      aria-label="Loading" />
                                <mat-icon>credit_card</mat-icon>{{checkoutLabel(plan)}}
                            </button>
                        </div>
                        }

                    </div>
                    } @else {
                    <div class="flex flex-wrap gap-4">
                        <button matButton="filled" type="button" (click)="managePlanOnClick()"
                                [showProgress]="vm.loading"
                                [disabled]="vm.loading"
                                aria-label="Manage subscription in Stripe customer portal">
                            <mat-progress-spinner progressIndicator
                                                  mode="indeterminate"
                                                  [diameter]="20"
                                                  aria-label="Loading" />
                            <mat-icon>settings</mat-icon>Manage Subscription
                        </button>
                    </div>
                    }

                </div>
            </div>



        </div>
    </mat-card-content>

</mat-card>

